import { render, staticRenderFns } from "./VModalMenu.vue?vue&type=template&id=04e183b1&scoped=true&"
import script from "./VModalMenu.vue?vue&type=script&lang=js&"
export * from "./VModalMenu.vue?vue&type=script&lang=js&"
import style0 from "./VModalMenu.vue?vue&type=style&index=0&id=04e183b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e183b1",
  null
  
)

export default component.exports